const s = /* @__PURE__ */ new Set([".mp4", ".webm", ".ogg", ".mov"]), a = (t) => {
  if (!t)
    return !1;
  let e;
  try {
    e = new URL(t).pathname;
  } catch {
    e = t;
  }
  const n = e.slice(e.lastIndexOf(".")).toLowerCase();
  return s.has(n);
}, o = (t, e) => e === 0 ? t : o(e, t % e), c = (t, e) => {
  const n = o(t, e);
  return `${t / n}:${e / n}`;
}, r = (t) => {
  if (!t)
    return "-";
  try {
    return new URL(t).pathname.split("/").pop() || "-";
  } catch {
    return t.split("/").pop() || "-";
  }
};
export {
  o as gcd,
  c as getAspectRatio,
  r as getFilenameFromUrl,
  a as isVideoUrl
};
//# sourceMappingURL=utils.js.map
